import { render, staticRenderFns } from "./PaymentFormFlat.vue?vue&type=template&id=52e70bff&scoped=true&"
import script from "./PaymentFormFlat.vue?vue&type=script&lang=js&"
export * from "./PaymentFormFlat.vue?vue&type=script&lang=js&"
import style0 from "./PaymentFormFlat.vue?vue&type=style&index=0&id=52e70bff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e70bff",
  null
  
)

export default component.exports